import React, { Component } from "react";
import { connect } from "react-redux";
import { mapStateToProps } from "@/store";
import { getAuthread, queryReadAccess } from "@/apis";
import PasswordPets from "./PasswordPets";

export default class Noauth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            authpwd: "",
            btnAuthTxt: "确认",
            subAuthBtn: false,
            noAuth: true,
            focused: false,
            authError: "",
        };
    }

    async componentDidMount() {
        const { nopeAuth } = this.props;
        const isLocalPreview =
            import.meta.env.DEV &&
            new URLSearchParams(window.location.search).has("preview");
        const isPassurl =
            isLocalPreview ||
            window.location.href.indexOf("dashboard") !== -1 ||
            window.location.href.indexOf("login") !== -1 ||
            window.location.href.indexOf("404") !== -1;
        if (isPassurl) {
            this.setState({
                noAuth: false,
            });
            return nopeAuth(false);
        }
        try {
            const authRet = await queryReadAccess();
            if (authRet.code === 200) {
                nopeAuth(false);
                this.setState({
                    noAuth: false,
                });
            }
        } catch (err) {
            nopeAuth(true);
            this.setState({
                noAuth: true,
            });
            console.error(err);
        }
    }

    async verifyAuth() {
        const { nopeAuth, dispatch } = this.props;

        try {
            if (!this.state.authpwd || this.state.authpwd === "") {
                this.setState({ authError: "请输入暗语" });
                return dispatch({
                    type: "SHOW_TOAST",
                    tstmsg: "请输入暗语 :(",
                });
            }

            this.setState({
                btnAuthTxt: "稍等…",
                subAuthBtn: true,
                focused: false,
                authError: "",
            });

            const authRet = await getAuthread(this.state.authpwd);

            if (!authRet.code || authRet.code !== 200) {
                this.setState({ authError: authRet.msg || "暗语不正确" });
                return dispatch({
                    type: "SHOW_TOAST",
                    tstmsg: authRet.msg || "系统错误~" + authRet.code,
                });
            }

            this.setState({
                btnAuthTxt: "确认",
                subAuthBtn: false,
                noAuth: false,
            });
            nopeAuth(false);
        } catch (err) {
            this.setState({
                authError: err?.data?.detail || err?.data?.msg || "暗语错误",
            });
            console.error(err);
            dispatch({
                type: "SHOW_TOAST",
                tstmsg: err?.data?.detail || err?.data?.msg || "暗语错误",
            });
        } finally {
            this.setState({
                btnAuthTxt: "确认",
                subAuthBtn: false,
            });
        }
    }
    render() {
        const { sword } = this.props;
        if (!!!this.state.noAuth) return null;

        return (
            <div className="box-pwd">
                <div className="box-pwd__card">
                    <PasswordPets
                        mood={
                            this.state.authError
                                ? "sad"
                                : this.state.focused
                                  ? "hide"
                                  : "idle"
                        }
                    />
                    <h2>这篇日记有一个小秘密</h2>
                    <p className="box-pwd__intro">
                        输入家人间的暗语，继续往下读。
                    </p>
                    <form
                        className="box-pwd__form"
                        onSubmit={(event) => {
                            event.preventDefault();
                            this.verifyAuth();
                        }}
                    >
                        <label htmlFor="read-passphrase">暗语</label>
                        <input
                            id="read-passphrase"
                            type="password"
                            autoComplete="off"
                            value={this.state.authpwd}
                            onFocus={() => this.setState({ focused: true })}
                            onBlur={() => this.setState({ focused: false })}
                            onChange={(event) =>
                                this.setState({
                                    authpwd: event.target.value,
                                    authError: "",
                                })
                            }
                            placeholder={sword || "请输入暗语"}
                        />
                        <p
                            className="box-pwd__feedback"
                            role="status"
                            aria-live="polite"
                        >
                            {this.state.authError ||
                                (this.state.focused
                                    ? "我们闭上眼睛，不偷看。"
                                    : "只和知道暗语的人分享。")}
                        </p>
                        <button type="submit" disabled={this.state.subAuthBtn}>
                            {this.state.btnAuthTxt}{" "}
                            <span aria-hidden="true">→</span>
                        </button>
                    </form>
                </div>
            </div>
        );
    }
}
Noauth = connect(mapStateToProps)(Noauth);
